export default "__VITE_ASSET__BdDJlNP8__"